import { onMounted, onBeforeUnmount, Ref } from 'vue';

/**
 * 横向滚动时锁定页面纵向滚动
 * @param elRef 横向滚动区域的 DOM 元素 ref
 */
const useScrollLock = (elRef: Ref<HTMLElement | null>) => {
    let isLocked = false;

    // 锁定滚动
    const lock = () => {
        if (isLocked) return;
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        isLocked = true;
    };

    // 解锁滚动
    const unlock = () => {
        if (!isLocked) return;
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        isLocked = false;
    };

    onMounted(() => {
        const element = elRef.value;
        if (!element) return;

        // 添加事件监听器
        element.addEventListener('scroll', lock, { passive: true });
        element.addEventListener('touchend', unlock, { passive: true });
        element.addEventListener('scrollend', unlock, { passive: true });
    });

    onBeforeUnmount(() => {
        const element = elRef.value;
        if (element) {
            // 移除事件监听器
            element.removeEventListener('scroll', lock);
            element.removeEventListener('touchend', unlock);
            element.removeEventListener('scrollend', unlock);
        }
        // 确保解锁
        unlock();
    });
};

export default useScrollLock;
